import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

const userTimezone = dayjs.tz.guess();

/** Date-times are read as UTC and shown in the browser's time zone; a bare "HH:mm:ss" time is shown as is. */
export const formatDateTime = (dateTime: string, formatString?: string): string => {
  if (dayjs(dateTime).isValid()) {
    return dayjs
      .utc(dateTime)
      .tz(userTimezone)
      .format(formatString ?? 'DD-MM-YYYY | hh:mm A');
  }

  if (dayjs(dateTime, 'HH:mm:ss').isValid()) {
    return dayjs(dateTime, 'HH:mm:ss').format(formatString ?? 'HH:mm A');
  }

  return '';
};
